import * as TypeGraphQL from "type-graphql";
export var OptionsContractScalarFieldEnum;
(function (OptionsContractScalarFieldEnum) {
    OptionsContractScalarFieldEnum["id"] = "id";
    OptionsContractScalarFieldEnum["symbol"] = "symbol";
    OptionsContractScalarFieldEnum["contractSymbol"] = "contractSymbol";
    OptionsContractScalarFieldEnum["optionType"] = "optionType";
    OptionsContractScalarFieldEnum["strikePrice"] = "strikePrice";
    OptionsContractScalarFieldEnum["expirationDate"] = "expirationDate";
    OptionsContractScalarFieldEnum["daysToExpiration"] = "daysToExpiration";
    OptionsContractScalarFieldEnum["lastPrice"] = "lastPrice";
    OptionsContractScalarFieldEnum["bidPrice"] = "bidPrice";
    OptionsContractScalarFieldEnum["askPrice"] = "askPrice";
    OptionsContractScalarFieldEnum["midPrice"] = "midPrice";
    OptionsContractScalarFieldEnum["bidSize"] = "bidSize";
    OptionsContractScalarFieldEnum["askSize"] = "askSize";
    OptionsContractScalarFieldEnum["volume"] = "volume";
    OptionsContractScalarFieldEnum["openInterest"] = "openInterest";
    OptionsContractScalarFieldEnum["impliedVolatility"] = "impliedVolatility";
    OptionsContractScalarFieldEnum["delta"] = "delta";
    OptionsContractScalarFieldEnum["gamma"] = "gamma";
    OptionsContractScalarFieldEnum["theta"] = "theta";
    OptionsContractScalarFieldEnum["vega"] = "vega";
    OptionsContractScalarFieldEnum["rho"] = "rho";
    OptionsContractScalarFieldEnum["inTheMoney"] = "inTheMoney";
    OptionsContractScalarFieldEnum["intrinsicValue"] = "intrinsicValue";
    OptionsContractScalarFieldEnum["extrinsicValue"] = "extrinsicValue";
    OptionsContractScalarFieldEnum["theoreticalPrice"] = "theoreticalPrice";
    OptionsContractScalarFieldEnum["underlyingPrice"] = "underlyingPrice";
    OptionsContractScalarFieldEnum["metadata"] = "metadata";
    OptionsContractScalarFieldEnum["dataTimestamp"] = "dataTimestamp";
    OptionsContractScalarFieldEnum["createdAt"] = "createdAt";
    OptionsContractScalarFieldEnum["updatedAt"] = "updatedAt";
})(OptionsContractScalarFieldEnum || (OptionsContractScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(OptionsContractScalarFieldEnum, {
    name: "OptionsContractScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=OptionsContractScalarFieldEnum.js.map